<template>
	<div class="userManageListing w-100">
		<b-col class="content pd-0">
			<b-tabs class="tabs-list">
				<!-- ALL -->
				<b-tab
					:active="filterListing === 'All' || filterListing === ''"
					@click="activeTab('All')"
				>
					<template v-slot:title>
						<FormatListBulletedIcon />
						<span>{{ $t('userDashboard.userManage.alllistings') }}</span>
					</template>
					<UserManageListingTab
						:filterListing="filterListing"
						:items="items"
						@resetItems="items = []"
					/>
				</b-tab>
				<!-- EXPIRED SOON -->
				<b-tab
					:active="filterListing === 'ExpiringSoon'"
					@click="
						activeTab('ExpiringSoon');
						updateNotSeen('ExpiringSoon');
						unSeenExpired = false;
					"
				>
					<template v-slot:title>
						<ClockOutlineIcon />

						<span>{{ $t('userDashboard.userManage.expiringSoon') }} </span>
						<div
							style="background:red;width:5px;height:5px;border-radius:50%;margin-bottom:20px;"
							v-if="unSeenExpired"
						></div>
					</template>
					<UserManageListingTab
						:filterListing="filterListing"
						:items="items"
						@resetItems="items = []"
					/>
				</b-tab>
				<!-- REJECTED -->
				<b-tab
					:active="filterListing === 'Rejected'"
					@click="
						activeTab('Rejected');
						updateNotSeen('Rejected');
						unSeenRejected = false;
					"
				>
					<template v-slot:title>
						<RepeatIcon />
						<span>{{ $t('userDashboard.userManage.rejected') }}</span>
						<div
							style="background:red;width:5px;height:5px;border-radius:50%;margin-bottom:20px;"
							v-if="unSeenRejected"
						></div>
					</template>
					<UserManageListingTab
						:filterListing="filterListing"
						:items="items"
						@resetItems="items = []"
					/>
				</b-tab>
				<!-- EXPIRED -->
				<b-tab
					:active="filterListing === 'Expired'"
					@click="activeTab('Expired')"
				>
					<template v-slot:title>
						<AlertCircleIcon />
						<span>{{ $t('userDashboard.userManage.expiredListing') }}</span>
					</template>
					<UserManageListingTab
						:filterListing="filterListing"
						:items="items"
						@resetItems="items = []"
					/>
				</b-tab>
				<!-- FAVORITE -->
				<b-tab
					:active="filterListing === 'Favorite'"
					@click="activeTab('Favorite')"
					:items="items"
					:tbody-tr-class="tbodyTrClass"
				>
					<template v-slot:title>
						<FavoriteOutlineIcon />
						<span>{{ $t('userDashboard.userManage.favListing') }}</span>
					</template>
					<UserManageListingTab
						:filterListing="filterListing"
						:items="items"
						@resetItems="items = []"
					/>
				</b-tab>
			</b-tabs>
		</b-col>
		<b-modal
			id="preview-model"
			v-model="showModelPreview"
			class="listing-preview-dialog"
			title="Preview Listing"
			size="xl"
			scrollable
		>
			<ListingDetail :listingDetailsFront="dataPreviewlisting" />
			<template v-slot:modal-footer="{ ok, cancel }">
				<div class="footer">
					<!-- Emulate built in modal footer ok and cancel button actions -->
					<b-button variant="success" id="accept" @click="ok()">OK</b-button>
					<b-button variant="danger" id="cancel" @click="cancel()"
						>Cancel</b-button
					>
					<!-- Button with custom close trigger value -->
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';

import UserManageListingTab from './UserManageListingTab';
import ListingDetail from '@/components/listing/listingDetail/ListingDetail';

// Icons
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';
import RepeatIcon from 'vue-material-design-icons/Repeat.vue';
import AlertCircleIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import FavoriteOutlineIcon from 'vue-material-design-icons/HeartOutline.vue';

export default {
	components: {
		UserManageListingTab,
		FormatListBulletedIcon,
		ClockOutlineIcon,
		RepeatIcon,
		AlertCircleIcon,
		FavoriteOutlineIcon,
		ListingDetail
	},
	data() {
		return {
			filterListing: 'All',
			items: [],
			dataPreviewlisting: null,
			showModelPreview: false,
			unSeenRejected: false,
			unSeenExpired: false
		};
	},
	computed: {
		...mapState('UserListingController', ['arrUserListing']),
		...mapState('AddListingController', ['arrListPreview'])
	},
	created() {
		if (this.$route.hash) {
			this.filterListing = this.$route.hash.substring(1);
		}
		this.getNotSeen();
	},
	watch: {
		arrUserListing: function(val) {
			this.setArrayListingTable(val);
		},
		arrListPreview: function(val) {
			if (val) {
				this.dataPreviewlisting = val;
				this.showModelPreview = true;
			}
		}
	},
	methods: {
		...mapActions('UserListingController', ['GET_NOT_SEEN', 'UPDATE_NOT_SEEN']),

		activeTab(tabName) {
			this.filterListing = tabName;
			this.items = [];
		},
		tbodyTrClass(items) {
			if (items.isFeature) {
				return 'hidden_header_featured_active';
			} else if (items.isHighlight) {
				return 'hidden_header_active';
			}
			return '';
		},

		async setArrayListingTable(val) {
			
			this.items = [];
			val.forEach(item => {
				let obj1 = {
					id: item.id,
					is_approved: item.is_approved,
					listing: item.title,
					status: item.status,
					expire_date: item.expiry_date,
					view: item.hits,
					province: item.province.name,
					district: item.district.name,
					expired: item.is_expired,
					img_url: item.url_feature_image,
					price: item.price,
					show_renew: item.is_show_renew ? item.is_show_renew : 0,
					user_payments: item.user_payments,
					parentCategory: item.listing_category.listing_category_parent.name,
					parentCategoryId: item.listing_category.listing_category_parent.id,
					subCategory: item.listing_category.name,
					minSalary: 0,
					salaryType: null
				};
				item.listing_attributes_details.forEach(subElement => {
					if (subElement.attr_id == 15) {
						obj1.minSalary = subElement.value ? subElement.value : 0;
					}
					if (subElement.attr_id == 18 && subElement.pre_values_id != 56) {
						obj1.salaryType = subElement.listing_pre_value.value
							? subElement.listing_pre_value.value
							: null;
					}
				});
				let obj2 = {
					isFeature: false,
					isHighlight: false,
					isQuickSale: false,
					isNegotiable: false
				};
				let obj3 = { favourites: null };
				if (item.favourites && item.favourites.length) {
					obj3 = {
						favourites: item.favourites[0].id || null
					};
				}
				if (item.user_payments.length) {
					item.user_payments[0].user_payments_details.forEach(data => {
						obj2 = {
							isFeature: data.packages_detail.package_id == 1 ? true : false,
							isHighlight:
								data.packages_detail.package_id == 1 ||
								data.packages_detail.package_id == 5
									? true
									: false,
							isQuickSale: data.packages_detail.package_id == 3 ? true : false,
							isNegotiable: data.packages_detail.package_id == 4 ? true : false
						};
					});
				}
				let obj4 = { unapproval_message: null };
				if (item.unapproval_message) {
					obj4 = {
						unapproval_message: item.unapproval_message
					};
				}
				let fullObj = { ...obj1, ...obj2, ...obj3, ...obj4 };
				this.items.push(fullObj);
			});
		},
		getNotSeen() {
			this.GET_NOT_SEEN().then(result => {
				this.unSeenRejected = result.data.rejected;
				this.unSeenExpired = result.data.expiringSoon;
			});
		},
		updateNotSeen(type) {
			this.UPDATE_NOT_SEEN(type).then(result => {
				
			});
		}
	}
};
</script>
<style lang="scss">
@import 'userManageListing.scss';
</style>
